import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AdminSessionService } from './admin-session.service';
import { LOGIN_PATH } from './auth-paths';
import { AuthSessionStore } from './auth-session.store';

export { LOGIN_PATH } from './auth-paths';

/**
 * Protects private areas. `canMatch` also prevents the lazy chunk (and any member request) from
 * loading for guests. An expired access token with a usable refresh token is renewed first.
 * UX only: the API authorizes every request.
 */
export const authGuard: CanMatchFn = async () => {
  const router = inject(Router);
  const session = inject(AuthSessionStore);
  const renewed = await inject(AdminSessionService).ensureSession();
  if (renewed) {
    return true;
  }
  session.clear();
  return router.parseUrl(LOGIN_PATH);
};

/** Keeps signed-in admins away from guest-only pages such as login. */
export const guestGuard: CanMatchFn = () =>
  inject(AuthSessionStore).isAuthenticated() ? inject(Router).parseUrl('/') : true;
